import React from 'react';

/**
 * App-wide loading screen — per brand spec:
 *   - Full-bleed black background
 *   - Eye icon stacked over the wordmark, both centered
 *   - Subtle pulse / glow animation on the eye (no separate spinner)
 *
 * Used by <Suspense> fallbacks and the initial app boot screen.
 */
export const LoadingScreen = ({ label }) => {
  return (
    <div
      className="fixed inset-0 z-[200] bg-black flex flex-col items-center justify-center gap-6"
      data-testid="loading-screen"
    >
      <img
        src="/favicon-512x512.png"
        alt=""
        aria-hidden
        className="w-24 h-24 md:w-28 md:h-28 object-contain"
        style={{
          animation: 'loading-eye-pulse 1.6s ease-in-out infinite',
          filter: 'drop-shadow(0 0 24px rgba(168, 85, 247, 0.5))',
        }}
        data-testid="loading-screen-eye"
      />
      <img
        src="/wordmark-tight.png"
        alt="AUDIVUE"
        className="h-6 md:h-7 w-auto object-contain"
        data-testid="loading-screen-wordmark"
      />
      {label && (
        <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mt-2">
          {label}
        </p>
      )}
    </div>
  );
};

export default LoadingScreen;
